import styles from './HaveFriends.module.css';
import {claimRewards} from '../../../Requests/referrals/referrals.ts';
import { useBalanceStore } from '../../../store/BalanceStore.ts';
import CopyButton from '../CopyButton/CopyButton.tsx';
import {useNotificationStore} from "../../../store/NotificationStore.ts";
import {useState} from "react";
import ButtonLoader from "../../../components/ButtonLoader/ButtonLoader.tsx";

interface IProps {
  total_collectable?: {
    beastcoins: number;
  };
  current_collectable?: {
    beastcoins: number;
  };
  referrals?: [
    {
      id: number;
      username: string;
      name: string;
      photo_url: string;
      beasts_earned: number;
    },
  ];
  total_referrals_count?: number;
  refreshReferrals: () => void;
}

const HaveFriends = ({
  referrals,
  total_collectable,
  current_collectable,
  refreshReferrals,
}: IProps) => {

  const [isProcessing, setIsProcessing] = useState(false);

  const balance = useBalanceStore((state) => state.balance);
  const setBalance = useBalanceStore((state) => state.setBalance);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const claimRewardsHandle = async () => {

    if (isProcessing) return

    setIsProcessing(true);

    const initData = window.Telegram?.WebApp.initData;
    if (initData) {
      try {
        const reward = await claimRewards(initData);

        if (reward && reward.beastcoins) {
          setBalance(balance + reward.beastcoins);
          await refreshReferrals();
          setNotification({
            type: "Success",
            message: "Доход собран",
            rewards: [{ amount: reward.beastcoins }],
          });
        } else {
          setNotification({
            type: "Error",
            message: "Нет дохода",
          });
        }
      } catch (e) {
        console.error("Произошла ошибка в claimRewardsHandle:", e);
      }
      setIsProcessing(false)
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.statsCards}>
        <div className={styles.statsCard}>
          <div className={styles.statsCard__title}>Получено за все время</div>
          <div className={styles.statsCard__img}>
            <div></div>
            <p>{total_collectable?.beastcoins}</p>
          </div>
        </div>
        <div className={styles.statsCard}>
          <div className={styles.statsCard__title}>Текущий баланс</div>
          <div className={styles.statsCard__img}>
            <div></div>
            <p>{current_collectable?.beastcoins}</p>
          </div>
        </div>
      </div>
      <div className={styles.claimRewardsSection}>
        <button onClick={claimRewardsHandle}>{isProcessing ? <ButtonLoader/> : "Собрать доход"}</button>
      </div>
      <div className={styles.referralContainer}>
        <div className={styles.referralTitle}>Рефералы</div>
        <div className={styles.referralList}>
          {referrals?.map((referral, i) => {
            return (
              <div className={styles.referralBlock} key={i}>
                <div className={styles.referralBlock__img}>
                  <img src={referral.photo_url} alt="pfp" />
                </div>
                <div className={styles.referralBlock__info}>
                  <div className={styles.referralName}>{referral.name}</div>
                  <div className={styles.referralEarned}>
                    <p>Принес дохода:</p>
                    <div className={styles.referralEarned__count}>
                      <div></div>
                      <div>{referral.beasts_earned}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <CopyButton />
        </div>
      </div>
    </div>
  );
};

export default HaveFriends;
